
import {
    FETCH_DEALS_SUCCESS,
    DEAL_UPDATE_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    deal: null,
    deals: null,
    pagination: null
  };
  
  export default function dealReducer (state=INITIAL_STATE, action) {

    switch (action.type) {
      case FETCH_DEALS_SUCCESS:
        return { ...state, deals: action.payload.deals, pagination: action.payload.pagination };
      case DEAL_UPDATE_SUCCESS:
        return { ...state, deal: action.payload.deal };
      default:
        return state;
    }
  };